export default __webpack_public_path__ + "static/media/graf-cta.afee06f2.svg";